import React, { ReactNode, useEffect, useState } from 'react'
import ModalUpload from 'components/Modal/ModalUpload/ModalUpload'
import { CREATIONS_MAX_FILE_SIZE, CREATIONS_MAX_FILES } from 'constant'
import VariableUtils from 'utils/variable'
import { useTranslation } from 'react-i18next'
import { DropZoneSize } from 'pages/Campaign/CampaignForm/CreationsForm/CreationsFormUpload/types'
import { VoohCreationDropZoneOptions } from '../../types'
import { RootState } from '../../../../store'
import service from './service'
import { useSelector } from 'react-redux'
import { AgencyType } from '../../../../types/agency'

const VoohCreationsFormUpload: React.FC<{
  onFinish: () => void
  maxVideoLength: number | null
}> = ({ onFinish, maxVideoLength }) => {
  const { t } = useTranslation()
  const [icon, setIcon] = useState<string | undefined>()
  const dropZoneOptions = VoohCreationDropZoneOptions
  const voohForm = useSelector((state: RootState) => state.voohCampaignForm.form)

  const loadIcon = (icon: string): void => {
    import(`images/${icon}.svg`).then(image => void setIcon(image.default))
  }

  useEffect(() => {
    loadIcon('dg-cl')
  }, [])

  const DropZoneRequirements = (): ReactNode => {
    const dropZoneOption = VoohCreationDropZoneOptions

    return !dropZoneOption ? (
      ''
    ) : (
      <div>
        {dropZoneOption.sizes.map((size: DropZoneSize, index) => {
          return (
            <p
              key={index}
              className='CreationsFormUpload__option'
            >
              {`${size.name}`} - <span>{`${size.width} x ${size.height}`} </span>
              {t('common.units.pixels')}
            </p>
          )
        })}
        {maxVideoLength && (
          <p className='CreationsFormUpload__option'>
            {t('form.campaign.creations.dropZoneOptions.maxMovieLength')}:{' '}
            <span>{maxVideoLength}</span> {t('common.units.seconds')}
          </p>
        )}
      </div>
    )
  }

  const DropHeader = (
    <div className='CreationsFormUpload__header--container'>
      <div className='CreationsFormUpload__header'>
        <img
          className='CreationsFormUpload__header--img'
          src={icon}
        />
        <div className='CreationsFormUpload__header--title'>{t(`mediaType.vooh`)}</div>
      </div>

      <div className='CreationsFormUpload__requirements'>
        {DropZoneRequirements()}

        <div className='CreationsFormUpload__accepted-formats'>
          {`${t('form.campaign.creations.acceptedFormats')}: `}
          <span className='CreationsFormUpload--title-bold'>
            {dropZoneOptions.acceptedFormats.join(', ')}
          </span>
        </div>
        <div>
          {`${t('form.campaign.creations.maxFileSize')}: `}
          <span className='CreationsFormUpload--title-bold'>
            {VariableUtils.formatBytes(CREATIONS_MAX_FILE_SIZE)}
          </span>
        </div>
        <div>
          {`${t('form.campaign.creations.maxFiles')}: `}
          <span className='CreationsFormUpload--title-bold'>{CREATIONS_MAX_FILES}</span>
        </div>
        <div className='CreationsFormUpload__zip-info'>{`${t(
          'form.campaign.creations.zipInfo'
        )}`}</div>
      </div>
    </div>
  )

  return (
    <>
      {DropHeader}

      <ModalUpload
        onDrop={(uploadedFiles, setLoading) => {
          void service.handleSubmit(
            voohForm.id,
            '',
            uploadedFiles,
            voohForm.detailsValues.hourFrequency || 0,
            setLoading,
            onFinish,
            voohForm.baseValues.agency?.rawData?.agencyType === AgencyType.internal
              ? voohForm.detailsValues.mediaDuration
              : undefined
          )
        }}
      />
    </>
  )
}

export default VoohCreationsFormUpload
